import React from "react";

const ErrorComponent500 = () => {
  return <h1>500 ERROR</h1>;
};

export default ErrorComponent500;
